import { Divider, Input, InputNumber, Row } from "antd";
import { FormItem } from "common/components/form/FormItem";
import { ComplementModel } from "api/generated";
import ResponsiveCol from "common/components/form/ResponsiveCol";
import { ExtraInfoBtn } from "common/helpers/generalUtils";
import {
  patternPermisoAlmacenamiento,
  validateCantidadMonetaria,
} from "services/utils/patterns";

export function StorageComplementForm() {
  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", borderColor: "#49f5f5ff" }}
      >
        Complemento - Almacenamiento
      </Divider>

      <Row gutter={24}>
        <FormItem<ComplementModel>
          hidden
          label="storage_id"
          name={["storage", "id"]}
        />

        <ResponsiveCol size="xl">
          <FormItem<ComplementModel>
            label="Terminal de almacenamiento"
            name={["storage", "terminal"]}
            rules={[
              { required: true, message: "Este campo es obligatorio" },
              {
                min: 5,
                message: "Por favor ingrese al menos 5 caracteres.",
              },
              {
                max: 250,
                message: "No se pueden ingresar más de 250 caracteres.",
              },
            ]}
          >
            <Input
              className="common-input"
              placeholder="Terminal"
              addonAfter={ExtraInfoBtn(
                "Terminal de almacenamiento del producto",
                [
                  "Cuando contrates servicios de almacenamiento, debes describir la terminal o instalación de almacenamiento",
                  "Ejemplo: TerminalAlm = Terminal de almacenamiento Pájaros vinculada a ductos de petrolíferos a través de un conjunto de instalaciones de almacenamiento, ubicada en la Zona Industrial Coatzacoalcos.",
                ]
              )}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Permiso de almacenamiento"
            name={["storage", "permission"]}
            rules={[
              { required: true, message: "Este campo es obligatorio" },
              {
                pattern: patternPermisoAlmacenamiento,
                message: "El valor ingresado no tiene un formato valido",
              },
            ]}
          >
            <Input
              className="common-input"
              placeholder="PermisoAlmacenamiento"
              addonAfter={ExtraInfoBtn("Permiso de almacenamiento", [
                "Debes registrar el número de permiso otorgado por la Comisión Reguladora de Energía",
                "Ejemplo: PermisoAlmacenamiento = LP/12345/ALM/2015",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Tarifa de Almacenamiento"
            name={["storage", "tariffAmount"]}
            rules={[
              { required: true, message: "Este campo es obligatorio" },
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              className="common-input"
              placeholder="TarifaDeAlmacenamiento"
              style={{ width: "100%" }}
              addonAfter={ExtraInfoBtn("Tarifa de Almacenamiento", [
                "Debes registrar la tarifa, en pesos mexicanos, que te cobraron por el servicio de almacenamiento.",
                "Ejemplos: TarifaDeAlmacenamiento = 58.69800",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Cargo por Capacidad"
            name={["storage", "capacityAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              className="common-input"
              placeholder="CargoPorCapacidadAlmac"
              style={{ width: "100%" }}
              addonAfter={ExtraInfoBtn(
                "Cargo por capacidad de almacenamiento",
                [
                  "La presencia de este elemento es opcional y debes registrar el cargo por capacidad de almacenamiento, en pesos mexicanos y sin impuestos, que te cobraron por el servicio contratado.",
                  "La cantidad manifestada deberá referirse al cargo diario que se cobra",
                  "Ejemplo: CargoPorCapacidadAlmac = 15.63100",
                ]
              )}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Cargo por uso"
            name={["storage", "useAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              className="common-input"
              placeholder="CargoPorUsoAlmac"
              style={{ width: "100%" }}
              addonAfter={ExtraInfoBtn(
                "Cargo por uso del servicio de almacenamiento",
                [
                  "La presencia de este elemento es opcional y debes registrar el cargo por uso del servicio de almacenamiento, en pesos mexicanos y sin impuestos, que te cobraron por el servicio de recepción o entrega de un barril en el sistema de almacenamiento.",
                  "Ejemplo: CargoPorUsoAlmac = 13.94600",
                ]
              )}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Cargo volumétrico"
            name={["storage", "volumetricAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              className="common-input"
              placeholder="CargoVolumetricoAlmac"
              style={{ width: "100%" }}
              addonAfter={ExtraInfoBtn(
                "Cargo único volumétrico del almacenamiento",
                [
                  "La presencia de este elemento es opcional y debes registrar el cargo único volumétrico del almacenamiento, en pesos mexicanos y sin impuestos, que ha de pagarse por los servicios conjuntos de recepción o entrega y almacenamiento de un barril en el sistema de almacenamiento",
                  "Ejemplo: CargoVolumetricoAlmac = 29.12000",
                ]
              )}
            />
          </FormItem>
        </ResponsiveCol>
      </Row>
    </div>
  );
}
